import { FormattedMessage as FM } from "react-intl";
import { DataTable } from "apps/AppointmentScheduling/components/table/DataTable";
import Button from "components/Buttons/StdButton";
import {
  TextColumn,
  TwoLineColumn,
  MoneyColumn,
  ChipColumn,
  StatusColumn,
  ActionsColumn,
} from "./TableColumns";

const STATE_COLOR_MAP = {
  draft: "bg-gray-100 text-gray-600",
  quotation: "bg-blue-100 text-blue-600",
  processing: "bg-amber-100 text-amber-600 font-bold",
  done: "bg-green-100 text-green-600 font-bold",
};

const ORDER_STATUS_LABEL = {
  commanded: "sale.sale.delivery.panel.status.commanded",
  dispatched: "sale.sale.delivery.panel.status.dispatched",
  draft: "sale.sale.delivery.panel.status.draft",
};

function getOrderStatusValue(row) {
  var id = ORDER_STATUS_LABEL[row.order_status];
  return id ? <FM id={id} /> : row.order_status;
}

export function DeliveryTable({
  records,
  selection,
  onSelectionChange,
  activeTab,
  onBilling,
  onPrint,
}) {
  return (
    <DataTable
      value={records}
      selectionMode="multiple"
      selection={selection}
      onSelectionChange={onSelectionChange}
      className="border-none"
    >
      <TextColumn
        field="number"
        labelId="sale.sale.delivery.panel.column.number"
        className="font-bold text-zinc-900"
      />
      <TwoLineColumn
        field="consumer.rec_name"
        labelId="sale.sale.delivery.panel.column.client"
        getPrimary={(row) =>
          row["consumer."]?.rec_name || row["party."]?.rec_name
        }
        getSecondary={(row) => row["shipment_address."]?.rec_name}
        fallbackId="sale.sale.delivery.panel.no_address"
      />
      <MoneyColumn
        field="total_amount"
        labelId="sale.sale.delivery.panel.column.total"
      />
      <MoneyColumn
        field="paid_amount"
        labelId="sale.sale.delivery.panel.column.paid_amount"
      />
      <MoneyColumn
        field="residual_amount"
        labelId="sale.sale.delivery.panel.column.residual_amount"
      />
      <MoneyColumn
        field="delivery_amount"
        labelId="sale.sale.delivery.panel.column.delivery_amount"
        bold={false}
        dashIfEmpty={true}
      />
      <ChipColumn
        field="payment_method"
        labelId="sale.sale.delivery.panel.column.payment"
      />
      <ChipColumn
        field="shipment_date"
        labelId="sale.sale.delivery.panel.column.shipment_date"
      />
      <ChipColumn
        field="delivery_time"
        labelId="sale.sale.delivery.panel.column.delivery_time"
      />
      <StatusColumn
        field="state"
        labelId="sale.sale.delivery.panel.column.state"
        colorMap={STATE_COLOR_MAP}
      />
      <TextColumn
        field="order_status"
        labelId="sale.sale.delivery.panel.column.order_status"
        className="text-xs text-zinc-500 italic"
        getValue={getOrderStatusValue}
      />
      <ActionsColumn
        labelId="sale.sale.delivery.panel.column.actions"
        actions={[
          {
            key: "bill",
            content: "sale.sale.delivery.panel.action.bill",
            color: "blue",
            Button,
            show: (row) => ["draft", "quotation"].includes(row.state),
            onClick: onBilling,
          },
          {
            key: "print",
            content: "sale.sale.delivery.panel.action.print",
            color: "amber",
            Button,
            // show: (row) => ["processing", "done"].includes(row.state),
            onClick: onPrint,
          },
        ]}
      />
    </DataTable>
  );
}
